export default __webpack_public_path__ + "static/frame1-903185192ede860b8e0c85042f574415.png";